export interface IndicatorPosition {
  title: string;
};

export const INDICATOR_POSITION_ABOVE: IndicatorPosition = {
  title: 'Above'
};

export const INDICATOR_POSITION_BEHIND_PRICE: IndicatorPosition = {
  title: 'Behind Price'
};

export const INDICATOR_POSITION_BELOW: IndicatorPosition = {
  title: 'Below'
};

export const INDICATOR_POSITION_BEHIND_INDICATOR: IndicatorPosition = {
  title: 'Behind Ind.'
};

export const DEFAULT_INDICATOR_POSITION: IndicatorPosition = INDICATOR_POSITION_BELOW;

export const INDICATOR_POSITIONS_ARRAY: IndicatorPosition[] = [
  INDICATOR_POSITION_ABOVE,
  INDICATOR_POSITION_BEHIND_PRICE,
  INDICATOR_POSITION_BELOW,
  INDICATOR_POSITION_BEHIND_INDICATOR
];
